<template>
  <el-table
    :data="serviceCategories"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'name', order: 'ascending'}"
  >
    <el-table-column
      prop="id"
      label="#"
      width="50"
      fixed
    />
    <el-table-column
      prop="name"
      label="Név"
      fixed
    />
    <el-table-column
      prop="services"
      label="Szolgáltatások"
    >
      <template slot-scope="scope">
        <el-tag
          v-if="scope.row.services && scope.row.services.length"
          type="primary"
        >
          {{ scope.row.services.length }} szolgáltatás
        </el-tag>
        <el-tag
          v-if="!scope.row.services || !scope.row.services.length"
          type="danger"
        >
          Nincs szolgáltatás
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :serviceCategory="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions';

  export default {

    components: {
      Actions
    },

    computed: {
      serviceCategories() {
        return this.$store.getters['serviceCategory/serviceCategories'];
      },

      loading() {
        return this.$store.getters['serviceCategory/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('serviceCategory/fetchAll');
    },
  };
</script>
